import { CommonModule, NgClass, NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { Nl2brPipe } from 'app/shared/pipes';

@Component({
  selector: 'app-panel-header',
  templateUrl: './panel-header.component.html',
  imports: [TranslateModule, MatIcon, NgClass, Nl2brPipe, CommonModule, NgIf],
  styles: ``,
})
export class PanelHeaderComponent {
  @Input() public title!: string;
  @Input() public subtitle!: string;
  @Input() public enableCustomization = false;
  @Output() public goBack = new EventEmitter<void>();
  @Output() public goToCustomize = new EventEmitter<void>();

  public back(): void {
    this.goBack.emit();
  }

  public customize(): void {
    this.goToCustomize.emit();
  }
}
